module.exports = __webpack_public_path__ + "img/86.7d797951.png";